import { render, staticRenderFns } from "./freePractice.vue?vue&type=template&id=7ad4f9ba&scoped=true"
import script from "./freePractice.vue?vue&type=script&lang=js"
export * from "./freePractice.vue?vue&type=script&lang=js"
import style0 from "./freePractice.vue?vue&type=style&index=0&id=7ad4f9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad4f9ba",
  null
  
)

export default component.exports